import { observer } from "mobx-react";
import ResolutionCard from "./resolution-card/resolution-card";
import "./choose-resolution-screen.scss";
import bankRefund from "./../../../../images/onboarding/bank-refund-resolution.png";
import giftCard from "./../../../../images/onboarding/gift-card-resolution.png";
import paymentMethod from "./../../../../images/onboarding/payment-method-resolution.png";
import productExchange from "./../../../../images/onboarding/product-exchange-resolution.png";
import storeCredit from "./../../../../images/onboarding/store-credit-resolution.png";
import variantExchange from "./../../../../images/onboarding/variant-exchange-resolution.png";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { RESOLUTION_ID } from "../../../resolutions/constants";
import { IStepComponent } from "../../onboarding-page";
import ChooseResolutionScreenStore from "../../stores/choose-resolution-screen-store";
import OnboardingDefaultNavigationControls from "../onboarding-default-navigation-controls/onboarding-default-navigation-controls";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";

export interface IOnboardingResolution {
    id: RESOLUTION_ID,
    title: string;
    description: string;
    imgSrc: string;
    disabled: boolean;
}

const ChooseResolutionScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as ChooseResolutionScreenStore;

    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    const resolutions: IOnboardingResolution[] = store.filterResolutions([
        {
            id: RESOLUTION_ID.REFUND_TO_CREDIT,
            title: getTranslation('STORE_CREDIT_TITLE', scope),
            description: getTranslation('STORE_CREDIT_DESCRIPTION', scope),
            imgSrc: storeCredit,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.REFUND_TO_CREDIT),
        },
        {
            id: RESOLUTION_ID.ORIG_PAY_REFUND,
            title: getTranslation('PAYMENT_METHOD_TITLE', scope),
            description: getTranslation('PAYMENT_METHOD_DESCRIPTION', scope),
            imgSrc: paymentMethod,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.ORIG_PAY_REFUND),
        },
        {
            id: RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE,
            title: getTranslation('VARIANT_EXCHANGE_TITLE', scope),
            description: getTranslation('VARIANT_EXCHANGE_DESCRIPTION', scope),
            imgSrc: variantExchange,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.INSTANT_VARIANT_EXCHANGE),
        },
        {
            id: RESOLUTION_ID.PRODUCT_EXCHANGE,
            title: getTranslation('PRODUCT_EXCHANGE_TITLE', scope),
            description: getTranslation('PRODUCT_EXCHANGE_DESCRIPTION', scope),
            imgSrc: productExchange,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.PRODUCT_EXCHANGE),
        },
        {
            id: RESOLUTION_ID.REFUND_TO_GIFT_CARD,
            title: getTranslation('GIFT_CARD_TITLE', scope),
            description: getTranslation('GIFT_CARD_DESCRIPTION', scope),
            imgSrc: giftCard,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.REFUND_TO_GIFT_CARD),
        },
        {
            id: RESOLUTION_ID.REFUND_TO_BANK,
            title: getTranslation('BANK_REFUND_TITLE', scope),
            description: getTranslation('BANK_REFUND_DESCRIPTION', scope),
            imgSrc: bankRefund,
            disabled: !store.isResolutionEnabled(RESOLUTION_ID.REFUND_TO_BANK),
        }
    ]);

    return (
        <div className="choose-resolution-screen">

            <OnBoardingScreenTitle
                titleText={getTranslation("CHOOSE_RESOLUTION_TITLE",scope)}
                descriptionText={
                    `${getTranslation("CHOOSE_RESOLUTION_SUBTITLE1",scope)}\n${getTranslation("CHOOSE_RESOLUTION_SUBTITLE2",scope)}`
                }
            />

            <div className="resolution-cards">
                {
                    resolutions
                        .map((resolution) => (
                            /** the component renders before we get translations respons, 
                             * so we prevent render cards without translations */
                            resolution.title &&
                            <ResolutionCard 
                                key={resolution.title} 
                                imgSrc={resolution.imgSrc} 
                                title={resolution.title} 
                                description={resolution.description}
                                disabled={resolution.disabled}
                                isEnabled={store.isResolutionSelected(resolution)}
                                onClick={() => store.toggleResolution(resolution)}
                            />
                        ))
                }
            </div>
            <OnboardingWizardStickyFooterPortal>
                <OnboardingDefaultNavigationControls
                    onBackClick={store.previousStep}
                    isNextDisabled={!store.isComplete()}
                    onNextClick={store.nextStep}
                    isLoading={store.isLoading}
                />
            </OnboardingWizardStickyFooterPortal>
        </div>
    )
});

export default ChooseResolutionScreen;
